<template>
    <fieldset :disabled="loading">
        <div id="divForm">
            <div>
                <div v-if="mustChooseAccount">
                    <form @submit.prevent="chooseAccount = false">
                        <div class="form-group">
                            <label>{{translate('login.accountCode')}}</label>
                            <input v-model="accountCode" type="text" class="form-control" aria-describedby="accountHelp"
                                required />
                        </div>
                        <div class="text-right">
                            <button type="submit" class="btn btn-primary">{{translate('login.continue')}}</button>
                        </div>
                    </form>
                </div>
                <div v-else>
                    <div>
                        <div style="margin-top:-20px;" class="text-center">
                            <span v-html="translate('login.eSignatureApprovalText:' + accountCode)"></span>
                        </div>
                        <div class="text-center" style="padding-bottom:26px;">
                            <button v-if="!isAccountCodeHidden" type="button"
                                @click="fingerprint = null; processingMessage = null; errorMessage = null; chooseAccount = true;"
                                class="btn btn-link">{{translate('login.changeAccount')}}</button>
                        </div>
                    </div>

                    <form @submit.prevent="getAgreement" v-if="!fingerprint">
                        <div class="form-group">
                            <label>{{translate('login.email')}}</label>
                            <input v-model="loginData.Email" type="email" class="form-control" required />
                        </div>
                        <!-- <div class="form-group">
                            <label>{{translate('login.gsmNumber')}}</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">+90</span>
                                </div>
                                <input v-model="loginData.GSM" type="tel" class="form-control" placeholder="5XXXXXXXXX"
                                    maxlength="10" required />
                            </div>
                        </div> -->
                        <div class="clear-fix">
                            <button type="submit" class="btn btn-success btn-block">{{translate('login.continue')}}</button>
                        </div>
                    </form>
                    <div v-else style="margin-top:-28px;">
                        <div class="text-center">
                            <div>{{ fingerprint.Email }}</div>
                            <div style="padding-bottom:30px;">{{ fingerprint.GSM }}</div>

                            <p><b>{{translate('mobileSignatureTexts.fingerprint')}}:</b></p>
                            <div style="width:180px; margin:auto;">
                                <code>{{ fingerprint.Fingerprint }}</code>
                            </div>
                            <div v-if="showbutton">
                                <button type="button" class="btn btn-success" style="margin-top:20px;"
                                    :disabled="loading" @click="sign">{{translate('mobileSignatureTexts.mobileSign')}}</button>
                            </div>
                            <div v-if="timerShow"
                                style="margin-top:14px; display:flex; justify-content: center; align-items: center;">
                                <div id="countDown" class="example__container" v-for="example in examples"
                                    :key="example.title">
                                    <h1>{{ example.title }}</h1>
                                    <circular-count-down-timer :circles="example.circles" :interval="example.interval"
                                        :main-circle-id="example.mainCircleId || '1'" :size="example.size"
                                        :container-classes="example.containerClasses"
                                        :circle-classes="example.circleClasses"
                                        :stop-conditions="example.stopConditions"
                                        :trigger-update="example.triggerUpdate" :stroke-width="example.strokeWidth"
                                        :stroke-color="example.strokeColor"
                                        :underneath-stroke-color="example.underneathStrokeColor"
                                        :fill-color="example.fillColor" :value-font-size="example.valueFontSize"
                                        :label-font-size="example.labelFontSize"
                                        :label-position="example.labelPosition" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-danger">
                    {{ errorMessage }}
                </div>
                <div v-if="processingMessage" style="padding-top: 15px;" class="text-center text-info">
                    {{ processingMessage }}</div>
            </div>
        </div>
    </fieldset>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'

export default {
    name: 'LoginWithESignature',
    components: {

    },
    data() {
        return {
            chooseAccount: true,
            accountCode: window.settings.defaultAccountCode,
            processingMessage: null,
            loading: false,
            signingItems: null,
            errorMessage: null,
            loginData: {},
            fingerprint: null,
            timerShow: false,
            showbutton: true,
            examples: [
                {
                    circles: [
                        {
                            strokeColor: "#17a2b8",
                            strokeWidth: 3,
                            id: '1',
                            steps: 60,
                            size: 50,
                            value: 60,
                            stepLength: -1,
                            dependentCircles: ['2']
                        }
                    ]
                }
            ]
        }
    },
    computed: {
        isAccountCodeHidden() {
            if (this.isOnPrem && window.settings.defaultAccountCode)
                return window.settings.authentication?.hideAccountCode;
            else
                return false;
        },
        mustChooseAccount() {
            return !this.isAccountCodeHidden && this.chooseAccount;
        }
    },
    methods: {
        getAgreement() {
            this.signingItems = null;
            this.errorMessage = '';
            this.loading = true;
            this.fingerprint = null;
            this.errorMessage = null;
            this.processingMessage = this.translate('processingMessages.calculatingFingerprint');
            return axios.post('token/Calculatefingerprint', {
                AccountCode: this.accountCode,
                Email: this.loginData.Email,
                // GSM: this.loginData.GSM
            })
                .then(x => {

                    this.accountCode = x.data.AccountCode;
                    this.fingerprint = x.data;
                    this.chooseAccount = false;
                    this.$forceUpdate();
                })
                .catch(x => {
                    window.processErrorResponse(x, this);
                    //alert('Oturum taahhütnamesi oluşturulamadı.');
                    console.log('Oturum taahhütnamesi oluşturulamadı: ', x);
                }).then(() => {
                    this.loading = false;
                    this.processingMessage = null;
                });
        },
        sign() {
            this.loading = true;
            this.errorMessage = '';
            this.processingMessage = this.translate('processingMessages.waitingMobileApproval');
            this.showbutton = false;
            this.timerShow = true;

            axios.post('token/SignMobile', {
                AccountCode: this.accountCode,
                Email: this.loginData.Email,
                // GSM: this.loginData.GSM,
                Agreement: this.fingerprint.Agreement,
                FingerPrintTempFileId: this.fingerprint.FingerPrintTempFileId
            })
                .then(x => {
                    console.log('MobileSign login result:', x);
                    if (x.data.Success) {
                        this.processingMessage = this.translate('processingMessages.redirecting');
                        window.localStorage.setItem('user', JSON.stringify(x.data.Data));
                        axios.defaults.headers.common['token'] = x.data.Data.Key;
                        this.$root.$data.login = x.data.Data;

                        if (this.$route.query.redirect)
                            this.$router.push(this.$route.query.redirect);
                        else
                            this.$router.push('/' + x.data.Data.Account.Code);

                    } else {
                        this.errorMessage = x.data.ErrorMessages;
                        this.loading = false;
                        this.fingerprint = null;
                        this.loginData.Email = null;
                        // this.loginData.GSM = null;
                        this.processingMessage = null;
                        this.timerShow = false;
                        this.showbutton = true
                    }
                })
                .catch(x => {
                    console.log('Mobile Oturum aç cevabı: ', x);
                    this.processingMessage = null;
                    this.loading = false;
                    this.loginData.Email = null;
                    // this.loginData.GSM = null;
                    window.processErrorResponse(x, this);
                })

        }
    }
}
</script>